import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);

import routes from "./routes.js";

import { all } from "./guards.js";

const routerMode = () => {
  const { host } = window.location;
  if (host === "sms.thinxtra.com" ||
      host === "staging.sms.thinxtra.com" ||
      host === "dev.sms.thinxtra.com") {
    return "history";
  }
  return "hash";
};

const router = new VueRouter({
  mode: routerMode(),
  routes
});

if (process.env.NODE_ENV === "production") {
  router.beforeEach(all);
}

export default router;



// WEBPACK FOOTER //
// ./src/router/router.js